import {
  AccordionTrigger,
  AccordionContent,
  AccordionItem,
  CardContent,
  CardHeader,
  CardTitle,
  Accordion,
  Loading,
  Card,
} from '@ui/components';
import { useHelpContent } from '@pages/help/hooks';
import { useTranslation } from 'react-i18next';
import * as React from 'react';

type FrequentlyAskedQuestionsProps = React.HTMLAttributes<HTMLDivElement>;

export const FrequentlyAskedQuestions: React.FC<FrequentlyAskedQuestionsProps> = (props) => {
  const { faqs, isFaqsLoading } = useHelpContent();
  const { t } = useTranslation();

  const sortedFaqs = faqs?.data.sort((a, b) => a.order - b.order);

  return (
    <Card {...props}>
      <CardHeader>
        <CardTitle>{t('HELP.FREQUENTLY_ASKED_QUESTIONS')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Loading isLoading={isFaqsLoading}>
          <Accordion className="divide-border-default" type="single" collapsible>
            {sortedFaqs?.map((faq, index) => (
              <AccordionItem value={index.toString()} key={index}>
                <AccordionTrigger>{t(faq.question)}</AccordionTrigger>
                <AccordionContent>{t(faq.answer)}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Loading>
      </CardContent>
    </Card>
  );
};
